// SABERA: 視力補正用レンズ案内の購入状況タブ。
// 2つのフローをページ遷移なしで切り替え、CSS側で高さと透明度を補間する。
(function () {
  'use strict';

  function initialize(root) {
    var tabs = Array.from(root.querySelectorAll('[data-prescription-flow-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-prescription-flow-panel]'));
    var panelContainer = root.querySelector('.prescription-detail__flow-panels');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cleanupTransition = null;

    if (tabs.length < 2 || panels.length < 2 || !panelContainer) return;

    function setState(state, moveFocus) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.prescriptionFlowTab === state;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) tab.focus();
      });

      panels.forEach(function (panel) {
        var active = panel.dataset.prescriptionFlowPanel === state;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        panel.inert = !active;
      });
    }

    function activate(state, moveFocus) {
      var currentPanel = panels.find(function (panel) {
        return panel.classList.contains('is-active');
      });
      var nextPanel = panels.find(function (panel) {
        return panel.dataset.prescriptionFlowPanel === state;
      });

      if (!nextPanel || currentPanel === nextPanel) {
        if (moveFocus) {
          var currentTab = tabs.find(function (tab) {
            return tab.dataset.prescriptionFlowTab === state;
          });
          if (currentTab) currentTab.focus();
        }
        return;
      }

      if (cleanupTransition) cleanupTransition();

      if (reducedMotion) {
        setState(state, moveFocus);
        return;
      }

      var startHeight = panelContainer.getBoundingClientRect().height;
      var finished = false;

      panelContainer.style.height = startHeight + 'px';
      panelContainer.classList.add('is-switching');
      panelContainer.getBoundingClientRect();

      setState(state, moveFocus);

      requestAnimationFrame(function () {
        panelContainer.style.height = nextPanel.scrollHeight + 'px';
      });

      function finish() {
        if (finished) return;
        finished = true;
        panelContainer.classList.remove('is-switching');
        panelContainer.style.removeProperty('height');
        panelContainer.removeEventListener('transitionend', onTransitionEnd);
        window.clearTimeout(fallbackTimer);
        cleanupTransition = null;
      }

      function onTransitionEnd(event) {
        if (event.target === panelContainer && event.propertyName === 'height') finish();
      }

      panelContainer.addEventListener('transitionend', onTransitionEnd);
      var fallbackTimer = window.setTimeout(finish, 650);
      cleanupTransition = finish;
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.prescriptionFlowTab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        activate(tabs[nextIndex].dataset.prescriptionFlowTab, true);
      });
    });
  }

  function initializeAll(container) {
    container.querySelectorAll('[data-prescription-flow]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
